module.exports = __webpack_public_path__ + "141d4a85/img/arrow-left-icon.785c715c.svg";